import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import $ from "jquery";

const General = ({ icon }) => {

    const [data, setData] = useState([]);
    const [id, setId] = useState(null);
    const getData = async () => {
        const { data } = await axios.get('/auth/general');
        setData(data);
        setId(data.id)
    };

    const [selectedFile, setSelectedFile] = useState(null);
    const uploadChange = async (e) => {
        const formData = new FormData();
        formData.append("file", e.target.files[0]);
        const { data } = await axios.post("/upload", formData);
        setSelectedFile(data);
    };

    useEffect(() => {
        getData();
        $('.nav-item').removeClass('active');
        $('.nav-item').each(function () {
            if ($(this).find('a').attr('href') === window.location.pathname) {
                $(this).addClass('active');
            }
        });
    }, [id]);

    return (
        <div className="page-content">
            <nav className="page-breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="/">Main</a></li>
                    <li className="breadcrumb-item active" aria-current="page">General</li>
                </ol>
            </nav>
            <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <h6 className="card-title">General Setting</h6>
                                </div>
                                <div className="col-md-12 d-flex">
                                    {console.log(id)}
                                    <form onSubmit={(e) => {
                                        e.preventDefault();
                                        const formData = new FormData(e.target);
                                        const data = Object.fromEntries(formData);
                                        axios.put(`/general/${id}`, data).then(() => {
                                            toast.success('updated successfully');
                                            getData();
                                        })
                                    }} >
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Description</label>
                                                    <input type="text" className="form-control" name="description" defaultValue={data.description} required />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Logo</label>
                                                    <input type="file" className="form-control" onChange={uploadChange} accept="application/pdf, image/*" />
                                                    <input type="hidden" name="logo" defaultValue={selectedFile ? selectedFile : data.logo} required />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Phone No1</label>
                                                    <input type="text" className="form-control" name="phone_1" defaultValue={data.phone_1} required />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Phone No2</label>
                                                    <input type="text" className="form-control" name="phone_2" defaultValue={data.phone_2} required />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Email 1</label>
                                                    <input type="text" className="form-control" name="email_1" defaultValue={data.email_1} required />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Email 2</label>
                                                    <input type="text" className="form-control" name="email_2" defaultValue={data.email_1} required />
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Address</label>
                                                    <input type="text" className="form-control" name="address" defaultValue={data.address} required />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Working Hour/Day</label>
                                                    <input type="text" className="form-control" name="work_time" defaultValue={data.work_time} required />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Google Map Embed</label>
                                                    <textarea className="form-control" name="map" rows={3} defaultValue={data.map} />
                                                </div>
                                            </div>

                                        </div>
                                        <button type="submit" className="btn btn-primary">Update</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}

export default General;